import React, { lazy } from "react"
import { Common } from "lib/types"
import { ReactComponent as StoreIcon } from "images/icons/store.svg"
import { ReactComponent as InventoryIcon } from "images/icons/warehouse.svg"
import { ReactComponent as TaxIcon } from "images/icons/badge-percent.svg"
import { PermissionGroups } from "../constants"

const Stores = lazy(() => import("views/Stores/Stores").then(m => ({ default: m.Stores })))
const StoreGroups = lazy(() => import("views/Stores/StoreGroups/StoreGroups").then(m => ({ default: m.StoreGroups })))
const Inventories = lazy(() => import("views/Inventories/Inventories").then(m => ({ default: m.Inventories })))
const Taxes = lazy(() => import("views/Taxes/Taxes").then(m => ({ default: m.Taxes })))

export const storeRoutes: Common.Views = [
  {
    element: <Stores />,
    path: "/stores",
    title: "Stores",
    icon: StoreIcon,
    sortOrder: 6,
    requiredGroups: PermissionGroups.stores.read,
    children: [
      {
        element: <StoreGroups />,
        path: "/stores/store-groups",
        title: "Store groups",
        icon: StoreIcon,
        parentPath: "/stores",
        section: "Store group"
      },
      {
        element: <Inventories />,
        path: "/stores/inventories",
        title: "Inventories",
        icon: InventoryIcon,
        parentPath: "/stores",
        requiredGroups: PermissionGroups.inventories.read,
        section: "Inventory"
      },
      {
        element: <Taxes />,
        path: "/stores/taxes",
        title: "Tax groups",
        icon: TaxIcon,
        section: "Tax groups",
        requiredGroups: PermissionGroups.tax.read
      }
    ]
  }
]
